// import CreateUser from "./CreateUser";
import Table from "../../../components/Table";
import React, { useState, useRef, useEffect } from "react";
import DynamicDropdown from "../../../components/Dropdown";
import ContextMenu from "../../../components/ContextMenu";
import { toast } from "../../../components/AppToast";
import { getalltenents } from "../../../services/tenant/tenant";
import dynamicFieldTransformer from "../../../utils/transformTenantData";
import TenantsManage from "../dashboard/TenantsManage";

const Tenants = () => {
  const [editData, setEditData] = useState(null);
  const [editTenantId, setEditTenantId] = useState(null); // <-- add this
  const [addNewData, ] = useState(false);
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, rowData: null });
  const gridRef = useRef();
  const [colData, setColData] = useState([]);

  const fieldsToDisplay = [
    '_id',
    'tenant_name',
    'tenant_type',
    'tenant_industryType',
    'address',
    'tenant_systemCapabilities',
    'status',
    'createdAt'
  ];

  const ExportDropdownData = [
    { value: "CSV", label: "Export as CSV" },
    // { value: "Excel", label: "Export as Excel" }
  ];

  const [userData, setUserData] = useState([]);
  const fetchUsers = async () => {
    try {
      const data = await getalltenents();



      const result = dynamicFieldTransformer(data, fieldsToDisplay);
      // console.table(result);

      setUserData(result || []);

      // console.log(Object.keys(result[0]));


      setColData(Object.keys(result[0]));

    } catch (err) {
      // toast.error(`Failed to fetch users: ${err}`);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, []);



  const handleEdit = () => {
    // console.log(contextMenu.rowData);

    setEditTenantId(contextMenu.rowData._id); // <-- set the id
    setEditData(contextMenu.rowData);
    setContextMenu({ ...contextMenu, visible: false });
  };

  const handleToggle = () => {
    setUserData(userData.map(user =>
      user._id === contextMenu.rowData._id ? { ...user, status: !user.status } : user))
    setContextMenu({ ...contextMenu, visible: false });

  };

  const AddButtonRenderer = (props) => {
    const iconRef = useRef();

    const handleIconClick = () => {
      if (iconRef.current) {
        const rect = iconRef.current.getBoundingClientRect();
        setContextMenu({
          visible: true,
          x: rect.right,
          y: rect.bottom,
          rowData: props.data,
        });
      }
    };

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <i
          ref={iconRef}
          className="bi bi-three-dots me-2 text-dark"
          style={{ cursor: "pointer", fontSize: "1.2rem", color: "#0d6efd" }}
          title="Edit"
          onClick={handleIconClick}
        ></i>
      </div>
    );
  };

  // function generateColumnDefs(columns) {
  //   const transformColData = columns
  //     .filter((key) => (key !== '_id' && key !== 'updatedAt' && key !== '__v')) // Exclude status column

  //     .map((key) => ({
  //       field: key,
  //       headerName: key
  //         .replace(/([A-Z])/g, " $1")
  //         .replace(/^./, (str) => str.toUpperCase())
  //         .trim(),
  //     }));
  //   return [
  //     ...transformColData,
  //     {
  //       field: "action",
  //       headerName: "Action",
  //       cellRenderer: AddButtonRenderer,
  //       width: 120,
  //     },
  //   ];
  // }


  function generateColumnDefs(columns) {
    const transformColData = columns
      .filter((key) => key !== '_id' && key !== 'updatedAt' && key !== '__v')
      .map((key) => {
        const formattedKey = key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase())
          .trim();

        const colDef = {
          field: key,
          headerName: formattedKey,
        };

        if (key === 'status') {
          colDef.cellRenderer = (params) => {
            const v = params.value;
            if (v == null || v === '') return null;
            const s = String(v);
            const pending = s.includes('Pending');
            const inactive = s.includes('Inactive') || s.includes('Deactiv');
            let cls = 'text-bg-secondary';
            if (pending) cls = 'text-bg-warning';
            else if (inactive) cls = 'text-bg-danger';
            else cls = 'text-bg-success';
            return (
              <span className={`badge rounded-pill px-2 py-1 fw-medium ${cls}`} style={{ fontSize: '0.75rem' }}>
                {s}
              </span>
            );
          };
          colDef.maxWidth = 200;
        }

        if (key === 'tenantSystemCapabilities') {
          colDef.cellRenderer = (params) => {
            if (!params.value) return null;

            // Split and clean the values
            const values = params.value
              .split(',')
              .map((item) => item.trim())
              .filter(Boolean);

            // Render each with a comma except the last
            return (
              <>
                {values.map((item, idx) => (
                  <div key={idx}>
                    {item}
                    {idx < values.length - 1 ? ',' : ''}
                  </div>
                ))}
              </>
            );
          };

          colDef.autoHeight = true;
          colDef.cellStyle = { whiteSpace: 'normal', lineHeight: '1.5' };
        }


        if (key === 'address') {
          colDef.cellRenderer = (params) => {
            if (!params.value) return null;

            // Split and clean the values
            const values = params.value
              .split(',')
              .map((item) => item.trim())
              .filter(Boolean);

            // Render each with a comma except the last
            return (
              <>
                {values.map((item, idx) => (
                  <div key={idx}>
                    {item}
                    {idx < values.length - 1 ? ',' : ''}
                  </div>
                ))}
              </>
            );
          };

          colDef.autoHeight = true;
          colDef.cellStyle = { whiteSpace: 'normal', lineHeight: '1.5' };
        }




        return colDef;
      });

    return [
      ...transformColData,
      {
        field: 'action',
        headerName: 'Action',
        cellRenderer: AddButtonRenderer,
        width: 120,
      },
    ];
  }

  const columnDefs = generateColumnDefs(colData);

  const handleExport = (type) => {
    if (!gridRef.current) return;
    if (type === "CSV") {
      gridRef.current.api.exportDataAsCsv();
    } else if (type === "Excel") {
      if (gridRef.current.api.exportDataAsExcel) {
        gridRef.current.api.exportDataAsExcel();
      } else {
        // alert("Excel export requires ag-Grid Enterprise.");
      }
    }
  };

  // const handleAddNew = () => {
  //   setAddNewData(!addNewData);
  // };

  useEffect(() => {

  }, []);
  const showList = !editTenantId && !editData && !addNewData;

  return (
    <div className="card shadow-lg main-card admin-tenant-card" style={{ position: 'relative' }}>
      <div className="card-header admin-tenant-card__header text-white border-0">
        {showList ? (
          <>
            <h4 className="mb-0 fw-semibold">Tenants</h4>
            <p className="mb-0 mt-1 small opacity-75">All registered tenants — open the row menu to edit or change status.</p>
          </>
        ) : (
          <h4 className="mb-0 fw-semibold">{addNewData ? 'Add new user' : 'Review tenant'}</h4>
        )}
      </div>
      <div className="card-body">
        {showList && (
          <div className="table-navbar d-flex align-items-center mb-3 gap-2 flex-wrap">
            {/* <button
              className="add-button btn fw-bold text-dark"
              onClick={handleAddNew}
            >
              <i className="bi bi-plus-lg me-1"></i> Add New
            </button> */}
            <DynamicDropdown
              options={ExportDropdownData}
              onSelect={(option) => handleExport(option.value)}
              placeholder={"Export Options"}
              className="dropdown-menu-right"
            />
          </div>
        )}
        {/* Table or Form */}
        {showList && (
          <Table
            rowData={userData}
            columnDefs={columnDefs}
            gridOptions={{
              suppressHorizontalScroll: true,
              getRowClass: params => params.data && params.data.status === false ? 'row-deactivated' : '',
            }}
            gridRef={gridRef}
            wrapClassName="admin-tenant-grid-wrap"
          />
        )}
        {editTenantId && (
          <TenantsManage
            id={editTenantId}
            onCancel={() => {
              setEditTenantId(null);
              setEditData(null);
            }}
          />
        )}
        {/* {addNewData && (
          <CreateUser
            onSubmit={(data) => {
              console.log("Create:", data);
            }}
            submitText="Create User"
            cancelText="Cancel"
            onCancel={onCancelhandler}
          />
        )}
        {editData && (
          <CreateUser
            initialValues={editData}
            onSubmit={(data) => {
              console.log("Update:", data);
            }}
            submitText="Update User"
            cancelText="Cancel"
            onCancel={onCancelhandler}
          />
        )} */}
      </div>
      <ContextMenu
        visible={contextMenu.visible}
        x={contextMenu.x}
        y={contextMenu.y}
        onClose={() => setContextMenu((prev) => ({ ...prev, visible: false }))}
        items={[
          {
            label: 'Edit',
            onClick: handleEdit,
          },
          {
            label: !contextMenu.rowData?.status ? 'Active' : 'Deactivate',
            onClick: handleToggle,
          },
        ]}
      />
    </div>
  );
};

export default Tenants;
